module.exports = __webpack_public_path__ + "img/VMware.9767bc4.svg";